import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=49e98345&scoped=true"
import script from "./MyOrders.vue?vue&type=script&lang=js"
export * from "./MyOrders.vue?vue&type=script&lang=js"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=49e98345&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e98345",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49e98345')) {
      api.createRecord('49e98345', component.options)
    } else {
      api.reload('49e98345', component.options)
    }
    module.hot.accept("./MyOrders.vue?vue&type=template&id=49e98345&scoped=true", function () {
      api.rerender('49e98345', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/MyOrders.vue"
export default component.exports